import React from "react";
import BlogPostThumbnail from "components/BlogPostThumbnail";

import * as styles from "./BlogPostThumbnailsContainer.module.less";

/**
 * @typedef {object} Props
 * @prop {readonly GatsbyTypes.BlogPostThumbnailFragment[]} posts
 *
 * @param {Props} props
 */
export default function BlogPostThumbnailsContainer({ posts }) {
  return (
    <div className={styles.blogPostThumbnailsContainer}>
      {posts.map((post, index) => (
        <div
          key={`suggestion-thumbnail-${index}`}
          className={styles.postThumbnailContainer}
        >
          <BlogPostThumbnail {...post} />
        </div>
      ))}
    </div>
  );
}
